import { useQuery } from '@tanstack/react-query';
import { adminDashboardService } from '@/services/adminDashboard';

export function useAdminStats() {
  return useQuery({
    queryKey: ['admin', 'stats'],
    queryFn: () => adminDashboardService.getStats(),
    staleTime: 60 * 1000, // 1 minute
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
  });
}

export function useSystemHealth() {
  return useQuery({
    queryKey: ['admin', 'health'],
    queryFn: () => adminDashboardService.getSystemHealth(),
    staleTime: 30 * 1000, // 30 seconds
    refetchInterval: 60 * 1000, // Refetch every minute
  });
}

export function useRecentActivity(limit: number = 10) {
  return useQuery({
    queryKey: ['admin', 'activity', limit],
    queryFn: () => adminDashboardService.getRecentActivity(limit),
    staleTime: 30 * 1000, // 30 seconds
    refetchInterval: 60 * 1000, // Refetch every minute
  });
}
